import BaseRestSerializer from '@square/dashboard-data/serializers/base-rest-serializer';
export default class EmberDataPaginatedSerializer extends BaseRestSerializer {
  extractMeta(_store, _typeClass, payload) {
    if (payload && Object.prototype.hasOwnProperty.call(payload, 'pagination_token')) {
      const meta = {
        nextPageToken: payload.pagination_token
      };
      delete payload.pagination_token;
      return meta;
    }
    return null;
  }
}